var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:`drag` + _vm.index,staticClass:"contain",attrs:{"id":`drag` + _vm.index,"draggable":"true"},on:{"dragstart":_vm.handle_dragstart,"drag":_vm.handle_drag,"drop":_vm.handle_ondrop,"dragover":_vm.allowDrop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }